/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import _, { filter } from 'lodash';
import { getManagerByDepartment, getRepsByManager } from '../../../api/medRepApi';
import useCWPAminContext from '../context/useCWPAminContext';

const departmentOptions = [
  { label: 'ALL', value: null },
  { label: 'KASD', value: 'KASD' },
  { label: 'SALES', value: 'SAR' },
];

function Filter() {
  const { auth, setFilterForm, filterForm, monthsOptions, yearOptions, searchCwp, clearCwp } =
    useContext(useCWPAminContext);

  const date = new Date();
  const [managerOptions, setManagerDrowndown] = useState([]);
  const [repOptions, setRepDrowndown] = useState([]);

  const loadRepDropdown = async () => {
    const months = filterForm?.month.map((row) =>
      row.value !== null ? parseFloat(row.value) : '',
    );

    const year = date.getFullYear().toString();

    const request = {
      department: filterForm?.department?.value ?? '',
      manager_id: auth.designation !== 'admin' ? auth.user_id : filterForm?.manager?.value,
      date_from:
        filterForm?.month.filter((item) => item.value === null).length > 0
          ? `${year}-01-01`
          : `${year}-${monthsOptions[Math.min(...months)].value}-01`,
      date_to:
        filterForm?.month.filter((item) => item.value === null).length > 0
          ? `${year}-12-31`
          : `${year}-${monthsOptions[Math.max(...months)].value}-31`,
      month: [],
      year: [],
      keyword: '',
    };
    const res = await getRepsByManager(request);
    const { code, data } = res.data;

    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.rep_id,
        label: row.rep_name,
      }));
      setRepDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadManagersDropdown = async () => {
    const request = {
      department: filterForm.department.value ?? '',
      head_id: '',
      keyword: '',
    };
    const res = await getManagerByDepartment(request);
    const { code, data } = res.data;

    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        // value: row.unique_id,
        // label: row.name,
        value: row.manager_id,
        label: row.manager_name,
      }));
      setManagerDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  useEffect(() => {
    loadRepDropdown();
    loadManagersDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        {auth.designation === 'admin' ? (
          <Grid md={2}>
            <Autocomplete
              disablePortal
              id='department'
              disableClearable
              fullWidth
              options={departmentOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Deparment' />}
              size='small'
              value={
                filterForm.department
                  ? departmentOptions.find((row) => row.value === filterForm.department.value)
                  : null
              }
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'department')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
        ) : (
          ''
        )}

        {auth.designation === 'admin' ? (
          <Grid md={2}>
            <Autocomplete
              disablePortal
              id='manager'
              disableClearable
              fullWidth
              options={managerOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Managers (KASM/SAM)' />}
              size='small'
              value={filterForm.manager}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'manager')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
        ) : (
          ''
        )}

        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='kasssar'
            disableClearable
            fullWidth
            options={repOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='KASS/SAR' />}
            size='small'
            value={filterForm.kasssar}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'kasssar')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            id='months'
            multiple
            fullWidth
            options={monthsOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm.month ?? []}
            noOptionsText='No Months'
            onChange={(event, newValue) => {
              setFilterForm({
                ...filterForm,
                month: newValue.length > 0 ? newValue : [monthsOptions[0]],
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Months' fullWidth />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>

        <Grid md={2}>
          <Button variant='contained' color='success' onClick={searchCwp}>
            Generate
          </Button>

          <Button
            variant='contained'
            color='primary'
            onClick={clearCwp}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
